import { usePage } from '@inertiajs/vue3';

export function useShopData() {
    return usePage().props.shop.shopData;
}
